// TODO: should share code with src/prize/scenes/Header/organisms/Menu/templates/Aragosta/molecules/Navigation/molecules/Links/molecules/Menu/molecules/Dropdown

import React, { useCallback, useLayoutEffect, useRef, FC } from 'react';
import cls from 'classnames';

import { INavItem } from 'src/prize/types/shoppe';

import { Link } from '../../../../atoms/Link';

import styles from './index.module.sass';

const sizeVertical = ( element?: HTMLElement ) => {
  if ( !element ) return '0';

  const elementStyle = getComputedStyle( element );
  return `${
    element.offsetHeight +
    parseInt( elementStyle.marginTop, 10 ) +
    parseInt( elementStyle.marginBottom, 10 )
  }px`;
};

interface IDropdownProps {
  className?: string;
  isExpanded: boolean;
  links?: INavItem[];
}

export const Dropdown: FC<IDropdownProps> = ({ className, isExpanded, links }) => {
  const containerRef = useRef<HTMLDivElement>( null );
  const contentRef = useRef<HTMLUListElement>( null );

  const size = useCallback(() => {
    const expandSize = sizeVertical( contentRef.current );
    const options = {
      duration: 200,
      easing: 'ease-out',
    };

    return {
      collapse: () =>
        containerRef.current?.animate([{ height: expandSize }, { height: 0 }], options ),
      expand: () => containerRef.current?.animate([{ height: 0 }, { height: expandSize }], options ),
    };
  }, []);

  useLayoutEffect(() => {
    if ( isExpanded ) {
      size().expand();
    } else {
      size().collapse();
    }
  }, [ isExpanded, size ]);

  return !links || links.length === 0 ? null : (
    <div
      className={cls( styles.container, { [styles.open]: isExpanded }, className )}
      ref={containerRef}
    >
      <ul className={cls( styles.content, { [styles.open]: isExpanded })} ref={contentRef}>
        {links.map(( link ) => (
          <li key={link.url}>
            <Link className={styles.link} href={link.url}>
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
